class Pinger {
  constructor(interval: number, callback: () => void) {
    this.INTERVAL = interval;
    this.CALLBACK = callback;
    this.startPinging();
  }

  private readonly INTERVAL: number; // pinging interval in milliseconds
  private readonly CALLBACK: () => void; // function to be executed on each ping
  private TIMER: any; // timeout instance

  public startPinging = () => {
    this.TIMER = setTimeout(() => {
      this.CALLBACK();
      this.startPinging();
    }, this.INTERVAL);
  };

  public stopPinging = () => {
    clearTimeout(this.TIMER);
  }
}

export default Pinger;
